import { useDocumentTitle } from '@/shared/hooks';
import { useUser } from '@clerk/react';
import { LeadFeedTable } from './LeadFeedTable';
import { useAccountLeads } from './hooks/useAccountLeads';

const AccountLeadsPage = () => {
  useDocumentTitle('Leads - BrokerMax');
  const { user } = useUser();
  const { data: rows = [], isLoading, error } = useAccountLeads();

  const name =
    user?.firstName ||
    user?.username ||
    user?.primaryEmailAddress?.emailAddress?.split('@')[0] ||
    'Agent';

  return (
    <div className="relative z-10">
      <h1 className="text-2xl font-bold tracking-tight text-slate-900 md:text-3xl">
        Leads
      </h1>
      <p className="mt-1 max-w-xl text-sm text-slate-700">
        Your assigned leads, {name}. Pricing was applied when each lead was
        matched to your wallet.
      </p>
      <div className="mt-8">
        <LeadFeedTable
          rows={rows}
          isLoading={isLoading}
          error={error ?? null}
        />
      </div>
    </div>
  );
};

export default AccountLeadsPage;
